"use client"

import { useMutation } from "@tanstack/react-query"
import {
  updateTiktokWebhookSubscriptionAction,
  type TiktokWebhookSubscription,
} from "@/server-actions/tiktok-webhook-subscription"
import { withQueryHandling } from "@/lib/with-query-handling"

/**
 * Points the TikTok app's webhook at this deployment.
 *
 * ⚠️ TikTok stores ONE callback URL per developer app, so running this from a
 * non-production deployment redirects every authorizing business's events here
 * — including production's. That is why dev and production need separate apps.
 */
export function useUpdateTiktokWebhookSubscriptionMutation() {
  return useMutation({
    mutationFn: async (): Promise<TiktokWebhookSubscription> => {
      const result = await withQueryHandling(updateTiktokWebhookSubscriptionAction({}), {
        loading: "Updating TikTok webhook subscription…",
        success: "TikTok webhook subscription updated",
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
